module.exports = __webpack_public_path__ + "static/img/coe-4ton-orange.296bcb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-orange.svg
// module id = VWpR
// module chunks = 74